export default __webpack_public_path__ + "static/media/trash.7e72f4b8.svg";